import { LOB_BEHAVIORAL, LOB_DENTAL, LOB_OHP } from './lob.constants';
import capitalize from 'lodash/capitalize';

// TODO: resolve CHCP disables by bot
// eslint-disable-next-line @typescript-eslint/naming-convention
export enum ENTITLEMENT_INDIVIDUAL {
  MedBh_CollaborativeCare = 'MedBh_CollaborativeCare',
  MedBh_ClaimsSearch = 'MedBh_ClaimsSearch',
  MedBh_ClaimsSearch_Reconsideration = 'MedBh_ClaimsSearch-Reconsideration',
  MedBh_ClaimsSearch_MessageCenterNotifications = 'MedBh_ClaimsSearch-MessageCenterNotifications',
  MedBh_ClaimSearch_Appeal_Read = 'MedBh_ClaimSearch-Appeal_Read',
  MedBh_ClinicalReports = 'MedBh_ClinicalReports',
  MedBh_DelegationAccessAndViews = 'MedBh_DelegationAccessAndViews',
  MedBh_DirectoryUpdates = 'MedBh_DirectoryUpdates',
  MedBh_EnrollAndManageEFT = 'MedBh_EnrollAndManageEFT',
  MedBh_PatientSearch = 'MedBh_PatientSearch',
  MedBh_PatientReviewsView = 'MedBh_PatientReviewsView',
  MedBh_Precertification = 'MedBh_Precertification',
  MedBh_RemittanceReports = 'MedBh_RemittanceReports',
  MedBh_BasicInformation = 'MedBh_BasicInformation',

  Den_BasicInformation = 'Den_BasicInformation',
  Den_DelegationAccessAndViews = 'Den_DelegationAccessAndViews',
  Den_PatientSearch = 'Den_PatientSearch',
  Den_ClaimsSearch = 'Den_ClaimsSearch',
  Den_DirectoryUpdates = 'Den_DirectoryUpdates',
  Den_EnrollAndManageEft = 'Den_EnrollAndManageEFT',
  Den_Precertification = 'Den_Precertification',
  Den_ClinicalReports = 'Den_ClinicalReports',
  Den_PatientReviewsView = 'Den_PatientReviewsView',
  Den_ClaimsSearch_Reconsideration = 'Den_ClaimsSearch-Reconsideration',
  Den_ClaimsSearch_MessageCenterNotifications = 'Den_ClaimsSearch-MessageCenterNotifications',

  FdOhp_BasicInformation = 'FdOhp_BasicInformation',
  FdOhp_PatientSearch = 'FdOhp_PatientSearch',
  FdOhp_ClaimsSearch = 'FdOhp_ClaimsSearch',
  FdOhp_ClaimsSearch_Reconsideration = 'FdOhp_ClaimsSearch-Reconsideration',
  FdOhp_ClaimsSearch_MessageCenterNotifications = 'FdOhp_ClaimsSearch-MessageCenterNotifications',
  FdOhp_ClaimSearch_Appeal_Read = 'FdOhp_ClaimSearch-Appeal_Read',
  FdOhp_RemittanceReports = 'FdOhp_RemittanceReports',
  FdOhp_DirectoryUpdates = 'FdOhp_DirectoryUpdates',
  FdOhp_EnrollAndManageEft = 'FdOhp_EnrollAndManageEFT',
  FdOhp_Precertification = 'FdOhp_Precertification',

  Ebh_BasicInformation = 'Ebh_BasicInformation',
  Ebh_PatientSearch = 'Ebh_PatientSearch',
  Ebh_ClaimsSearch = 'Ebh_ClaimsSearch',
  Ebh_ClaimsSearch_Reconsideration = 'Ebh_ClaimsSearch-Reconsideration',
  Ebh_ClaimsSearch_MessageCenterNotifications = 'Ebh_ClaimsSearch-MessageCenterNotifications',
  Ebh_ClaimSearch_Appeal_Read = 'Ebh_ClaimSearch-Appeal_Read',
  Ebh_RemittanceReports = 'Ebh_RemittanceReports',
  Ebh_DirectoryUpdates = 'Ebh_DirectoryUpdates',
  Ebh_EnrollAndManageEft = 'Ebh_EnrollAndManageEFT',
  Ebh_Precertification = 'Ebh_Precertification',
}

export const ENTITLEMENT_GROUP_CLAIM_SEARCH = [
  ENTITLEMENT_INDIVIDUAL.MedBh_ClaimsSearch,
  ENTITLEMENT_INDIVIDUAL.Den_ClaimsSearch,
  ENTITLEMENT_INDIVIDUAL.FdOhp_ClaimsSearch,
  ENTITLEMENT_INDIVIDUAL.Ebh_ClaimsSearch,
];

export const ENTITLEMENT_GROUP_CLAIM_RECONSIDERATION = [
  ENTITLEMENT_INDIVIDUAL.MedBh_ClaimsSearch_Reconsideration,
  ENTITLEMENT_INDIVIDUAL.FdOhp_ClaimsSearch_Reconsideration,
  ENTITLEMENT_INDIVIDUAL.Den_ClaimsSearch_Reconsideration,
  ENTITLEMENT_INDIVIDUAL.Ebh_ClaimsSearch_Reconsideration,
];

export const ENTITLEMENT_GROUP_CLAIM_MESSAGE_CENTER = [
  ENTITLEMENT_INDIVIDUAL.Den_ClaimsSearch_MessageCenterNotifications,
];

export const ENTITLEMENT_GROUP_PRECERTIFICATION = [
  ENTITLEMENT_INDIVIDUAL.MedBh_Precertification,
];

export const ENTITLEMENT_GROUP_PATIENT_SEARCH = [
  ENTITLEMENT_INDIVIDUAL.MedBh_PatientSearch,
  ENTITLEMENT_INDIVIDUAL.Den_PatientSearch,
  ENTITLEMENT_INDIVIDUAL.FdOhp_PatientSearch,
  ENTITLEMENT_INDIVIDUAL.Ebh_PatientSearch,
];

export const ENTITLEMENT_GROUP_DELEGATION = [
  ENTITLEMENT_INDIVIDUAL.MedBh_DelegationAccessAndViews,
  ENTITLEMENT_INDIVIDUAL.Den_DelegationAccessAndViews,
  ENTITLEMENT_INDIVIDUAL.MedBh_DelegationAccessAndViews,
];

export const ENTITLEMENT_GROUP_EFT = [
  ENTITLEMENT_INDIVIDUAL.MedBh_EnrollAndManageEFT,
  ENTITLEMENT_INDIVIDUAL.Den_EnrollAndManageEft,
  ENTITLEMENT_INDIVIDUAL.FdOhp_EnrollAndManageEft,
  ENTITLEMENT_INDIVIDUAL.Ebh_EnrollAndManageEft,
];

export const ENTITLEMENT_GROUP_DIRECTORY_UPDATES = [
  ENTITLEMENT_INDIVIDUAL.MedBh_DirectoryUpdates,
  ENTITLEMENT_INDIVIDUAL.Den_DirectoryUpdates,
  ENTITLEMENT_INDIVIDUAL.FdOhp_DirectoryUpdates,
  ENTITLEMENT_INDIVIDUAL.Ebh_DirectoryUpdates,
];

export const ENTITLEMENT_GROUP_PATIENT_REVIEWS_VIEW = [
  ENTITLEMENT_INDIVIDUAL.MedBh_PatientReviewsView,
  // ENTITLEMENT_INDIVIDUAL.Den_PatientReviewsView,
];

export const ENTITLEMENT_GROUP_PATIENT_FEE_SCHEDULE = [
  ENTITLEMENT_INDIVIDUAL.MedBh_ClaimsSearch,
  ENTITLEMENT_INDIVIDUAL.MedBh_EnrollAndManageEFT,
];

export const ENTITLEMENT_GROUP_ONE_HEALTH_PORT = [
  ENTITLEMENT_INDIVIDUAL.FdOhp_BasicInformation,
  ENTITLEMENT_INDIVIDUAL.FdOhp_PatientSearch,
  ENTITLEMENT_INDIVIDUAL.FdOhp_ClaimsSearch,
  ENTITLEMENT_INDIVIDUAL.FdOhp_RemittanceReports,
  ENTITLEMENT_INDIVIDUAL.FdOhp_DirectoryUpdates,
  ENTITLEMENT_INDIVIDUAL.FdOhp_EnrollAndManageEft,
  ENTITLEMENT_INDIVIDUAL.FdOhp_Precertification,
];

const medicalEntitlementPrefix = 'MedBh';
const dentalEntitlementPrefix = 'Den';
const fdohpEntitlementPrefix = 'FdOhp';
const behavioralEntitlementPrefix = 'Ebh';

const isUpperCase = (str: string): boolean => str === str.toUpperCase();

// used only for local dev mocking
export const ALL_ENTITLEMENTS_MEDICAL = Object.values(
  ENTITLEMENT_INDIVIDUAL,
).filter((val) => val.startsWith(medicalEntitlementPrefix));

export const ALL_ENTITLEMENTS_DENTAL = Object.values(
  ENTITLEMENT_INDIVIDUAL,
).filter((val) => val.startsWith(dentalEntitlementPrefix));

export const ALL_ENTITLEMENTS_FDOHP = Object.values(
  ENTITLEMENT_INDIVIDUAL,
).filter((val) => val.startsWith(fdohpEntitlementPrefix));

export const ALL_ENTITLEMENTS_BEHAVIORAL = Object.values(
  ENTITLEMENT_INDIVIDUAL,
).filter((val) => val.startsWith(behavioralEntitlementPrefix));

// take lob and entitlement as plain string and convert to entitlement format we get in JWT as defined in ENTITLEMENT_INDIVIDUAL
// eg, ("MEDBH", "Delegation access and views") => "MedBh_DelegationAccessAndViews"
export const mapEntitlementToTokenFormat = (
  lob: string,
  entitlement: string,
): string =>
  `${
    lob === LOB_DENTAL
      ? dentalEntitlementPrefix
      : lob === LOB_OHP
      ? fdohpEntitlementPrefix
      : lob === LOB_BEHAVIORAL
      ? behavioralEntitlementPrefix
      : medicalEntitlementPrefix
  }_${entitlement
    .split(' ')
    .map((v) => (isUpperCase(v) ? v : capitalize(v)))
    .join('')}`;
